export enum EMaterielSediment {
    CarottierManuel = 1,
    BenneEkman = 2,
    BenneVanVeen = 3
}
